import { render } from "./Pulling.vue?vue&type=template&id=190ef7b4&scoped=true"
import script from "./Pulling.vue?vue&type=script&lang=js"
export * from "./Pulling.vue?vue&type=script&lang=js"

import "./Pulling.vue?vue&type=style&index=0&id=190ef7b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190ef7b4"]])

export default __exports__